import { createApp } from 'vue';
import Main from './App.vue';
import visible from '../../../directive/visible';
import WebpSupportPlugin from '@ks-open-platform-ketang/cdn-image-min';

function init(): void {
    const app = createApp(Main);
    app.directive('visible', visible);
    app.use(WebpSupportPlugin);
    app.mount('#app');
}
init();
